import axios from "axios";
import isEmpty from "is-empty";

class axiosVirdioT {

	constructor(props)
		{
			this.defaultAxiosRetry = 10;
			this.urlObject = [];
			this.paramsObject = [];
			if ( localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")) && JSON.parse(localStorage.getItem("userData")).default )
				{
					this.defaultAxiosRetry = JSON.parse(localStorage.getItem("userData")).default.defaultAxiosRetry;
				}
			
			this.props = props;
		}
	
	post(url, parObject, insertAxios)
		{
			return new Promise((resolve, reject) => {
				let mainthis = this;
				let tempUrl = url;
				this.urlObject.push(tempUrl);
				let tryAgain = false;
				if ( !isEmpty(parObject) )
					{
						this.paramsObject.push(parObject);
					}
				else
					{
						this.paramsObject.push({});
						parObject = {};
					}
				let tempInsertAxios = insertAxios;
				setTimeout( function(){
					let ind2 = mainthis.urlObject.indexOf(tempUrl);
					if ( tempInsertAxios )
						{
							if ( ind2 > -1 )
								{
									mainthis.urlObject.splice(ind2, 1);
									mainthis.paramsObject.splice(ind2, 1);
								}
						}
					else
						{
							if ( ind2 > -1 )
								{
									if ( tryAgain )
										{
											axios.post(mainthis.urlObject[ind2], mainthis.paramsObject[ind2])
											.then(res => {
												mainthis.urlObject.splice(ind2, 1);
												mainthis.paramsObject.splice(ind2, 1);
												resolve(res);
											}).catch(err =>{
												if ( err.toJSON() && err.toJSON().message && err.toJSON().message == 'Network Error' ) 
													{
														if ( mainthis.props )
															{
																mainthis.props.showMainErrorPop("No internet connection. Please check your internet connection and try again."); 
																reject(err);
															}
														else
															{
																reject({"response":{"data": { "errorData": "No internet connection. Please check your internet connection and try again."}}});
															}
													}
											});
										}
								}
						}
				}, (mainthis.defaultAxiosRetry*1000));
				
				axios.post(tempUrl, parObject)
				.then(res => {
					let ind = mainthis.urlObject.indexOf(tempUrl);
					mainthis.urlObject.splice(ind, 1);
					mainthis.paramsObject.splice(ind, 1);
					resolve(res);
				}).catch(err =>{
					if ( err.toJSON() && err.toJSON().message && err.toJSON().message == 'Network Error' ) 
						{
							if ( mainthis.props && mainthis.props.showMainErrorPop && tryAgain )
								{
									mainthis.props.showMainErrorPop("No internet connection. Please check your internet connection and try again."); 
									reject(err);
								}
							else if ( tryAgain )
								{
									reject({"response":{"data": { "errorData": "No internet connection. Please check your internet connection and try again."}}});
								}
							tryAgain = true;
						}
					else
						{ 
							 if ( mainthis.props && mainthis.props.showMainErrorPop && err.response && err.response.data && err.response.data.errorData && typeof err.response.data.errorData == 'String' )
								{
									mainthis.props.showMainErrorPop(err.response.data.errorData);
								}
							reject(err);
						}
					
				});
			});
		}
		
	get(url)
		{
			return new Promise((resolve, reject) => {
				axios.get(url)
				.then(res => {
					resolve(res);
				}).catch(err =>{
					reject(err);
				});
			});
		}
		
	put(url, parObject)
		{
			return new Promise((resolve, reject) => {
				axios.put(url, parObject)
				.then(res => {
					resolve(res);
				}).catch(err =>{
					reject(err);
				});
			});
		}
		
	patch(url, parObject)
		{
			return new Promise((resolve, reject) => {
				axios.patch(url, parObject)
				.then(res => {
					resolve(res);
				}).catch(err =>{
					reject(err);
				});
			});
		}
		
	auth(token)
		{
			axios.defaults.headers.common['Authorization'] = token;
		}
}

export default axiosVirdioT;